document.addEventListener("DOMContentLoaded", function () {
  var PERSON_NAME_MIN = 2;
  var PERSON_NAME_MAX = 40;
  var PERSON_NAME_FORBIDDEN = /[0-9@#{}<>$%^&*()+=[\]!~|\\/\"`_;:,.?]/;
  var PERSON_NAME_FIELDS = ["first-name", "last-name"];
  var EMAIL_FIELDS = ["email", "your-email"];
  var EMAIL_INVALID_MESSAGE = "Please enter a valid email address.";
  var EMAIL_PATTERN = /^[^\s@]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  var CONTACT_FORM_ROOT =
    ".contact-section, #contactForm, .contact-right";

  function isContactFormField(input) {
    return input && input.closest(CONTACT_FORM_ROOT);
  }

  function isPersonNameField(input) {
    return (
      input &&
      input.tagName === "INPUT" &&
      PERSON_NAME_FIELDS.indexOf(input.name) !== -1 &&
      isContactFormField(input)
    );
  }

  function isEmailField(input) {
    return (
      input &&
      input.tagName === "INPUT" &&
      input.type === "email" &&
      EMAIL_FIELDS.indexOf(input.name) !== -1 &&
      isContactFormField(input)
    );
  }

  function validatePersonName(value) {
    var v = (value || "").trim();

    if (!v) {
      return { valid: true };
    }

    if (v.length < PERSON_NAME_MIN) {
      return {
        valid: false,
        message: "Please enter at least 2 characters.",
      };
    }

    if (v.length > PERSON_NAME_MAX) {
      return {
        valid: false,
        message: "Please enter no more than 40 characters.",
      };
    }

    if (PERSON_NAME_FORBIDDEN.test(v)) {
      return {
        valid: false,
        message:
          "Only letters, spaces, hyphens, and apostrophes are allowed.",
      };
    }

    return { valid: true };
  }

  function validateEmail(value) {
    var v = (value || "").trim();

    if (!v) {
      return { valid: true };
    }

    if ((v.match(/@/g) || []).length !== 1 || !EMAIL_PATTERN.test(v)) {
      return {
        valid: false,
        message: EMAIL_INVALID_MESSAGE,
      };
    }

    return { valid: true };
  }

  function getPersonNameInputs(form) {
    var inputs = [];

    PERSON_NAME_FIELDS.forEach(function (fieldName) {
      var input = form.querySelector('input[name="' + fieldName + '"]');
      if (input) {
        inputs.push(input);
      }
    });

    return inputs;
  }

  function getEmailInputs(form) {
    var inputs = [];

    EMAIL_FIELDS.forEach(function (fieldName) {
      var input = form.querySelector('input[name="' + fieldName + '"]');
      if (input) {
        inputs.push(input);
      }
    });

    return inputs;
  }

  function getControlWrap(input) {
    return (
      input.closest(".wpcf7-form-control-wrap") || input.parentElement
    );
  }

  function removeCf7Tips(wrap) {
    if (!wrap) {
      return;
    }

    wrap.querySelectorAll(".wpcf7-not-valid-tip").forEach(function (tip) {
      tip.remove();
    });
  }

  function removeCustomErrors(wrap, errorClass) {
    if (!wrap) {
      return;
    }

    wrap.querySelectorAll("." + errorClass).forEach(function (tip) {
      tip.remove();
    });
  }

  function clearFieldError(input, errorClass) {
    var wrap = getControlWrap(input);
    if (!wrap) {
      return;
    }

    input.classList.remove("wpcf7-not-valid");
    input.setAttribute("aria-invalid", "false");
    input.removeAttribute("aria-describedby");

    removeCustomErrors(wrap, errorClass);
    removeCf7Tips(wrap);
  }

  function showFieldError(input, message, errorClass) {
    var wrap = getControlWrap(input);
    if (!wrap) {
      return;
    }

    removeCf7Tips(wrap);

    var tips = wrap.querySelectorAll("." + errorClass);
    var tip = tips[0] || null;

    // Remove duplicate custom error nodes, keep the first one
    for (var i = 1; i < tips.length; i++) {
      tips[i].remove();
    }

    input.classList.add("wpcf7-not-valid");
    input.setAttribute("aria-invalid", "true");

    if (tip) {
      tip.textContent = message;
      tip.setAttribute("aria-hidden", "false");

      if (!tip.id) {
        tip.id = (input.name || "field") + "-error";
      }

      input.setAttribute("aria-describedby", tip.id);
      return;
    }

    tip = document.createElement("span");
    tip.className = errorClass;
    tip.setAttribute("role", "alert");
    tip.setAttribute("aria-hidden", "false");
    tip.id = (input.name || "field") + "-error";

    if (input.nextSibling) {
      wrap.insertBefore(tip, input.nextSibling);
    } else {
      wrap.appendChild(tip);
    }

    tip.textContent = message;
    input.setAttribute("aria-describedby", tip.id);
  }

  function validatePersonNameInput(input, showError) {
    var result = validatePersonName(input.value);

    if (result.valid) {
      clearFieldError(input, "centrio-person-name-error");
      return true;
    }

    if (showError) {
      showFieldError(input, result.message, "centrio-person-name-error");
    }

    return false;
  }

  function validateEmailInput(input, showError) {
    var result = validateEmail(input.value);

    if (result.valid) {
      clearFieldError(input, "centrio-email-error");
      return true;
    }

    if (showError) {
      showFieldError(input, result.message, "centrio-email-error");
    }

    return false;
  }

  function validateContactFormFields(form, showErrors) {
    var firstInvalid = null;
    var allValid = true;

    getPersonNameInputs(form).forEach(function (input) {
      if (!validatePersonNameInput(input, showErrors)) {
        allValid = false;
        if (!firstInvalid) {
          firstInvalid = input;
        }
      }
    });

    getEmailInputs(form).forEach(function (input) {
      if (!validateEmailInput(input, showErrors)) {
        allValid = false;
        if (!firstInvalid) {
          firstInvalid = input;
        }
      }
    });

    if (firstInvalid && showErrors) {
      firstInvalid.focus();
    }

    return allValid;
  }

  function consolidateFieldError(input, errorClass, validateFn) {
    window.setTimeout(function () {
      validateFn(input, true);
    }, 0);

    // CF7 may inject its own tip after blur — strip it, never add a second custom tip
    window.setTimeout(function () {
      var wrap = getControlWrap(input);
      if (!wrap) {
        return;
      }

      removeCf7Tips(wrap);

      var tips = wrap.querySelectorAll("." + errorClass);
      for (var i = 1; i < tips.length; i++) {
        tips[i].remove();
      }
    }, 100);
  }

  function runBlurValidation(input) {
    if (!isContactFormField(input)) {
      return;
    }

    window.setTimeout(function () {
      if (isPersonNameField(input)) {
        consolidateFieldError(
          input,
          "centrio-person-name-error",
          validatePersonNameInput
        );
      }

      if (isEmailField(input)) {
        consolidateFieldError(
          input,
          "centrio-email-error",
          validateEmailInput
        );
      }
    }, 0);
  }

  document.addEventListener(
    "focusout",
    function (event) {
      runBlurValidation(event.target);
    },
    true
  );

  document.addEventListener("input", function (event) {
    var input = event.target;

    if (isPersonNameField(input)) {
      input.setAttribute("maxlength", String(PERSON_NAME_MAX));

      var wrap = getControlWrap(input);
      var hasError =
        input.classList.contains("wpcf7-not-valid") ||
        (wrap && wrap.querySelector(".centrio-person-name-error"));

      if (hasError) {
        validatePersonNameInput(input, true);
      }
      return;
    }

    if (isEmailField(input)) {
      var emailWrap = getControlWrap(input);
      var hasEmailError =
        input.classList.contains("wpcf7-not-valid") ||
        (emailWrap && emailWrap.querySelector(".centrio-email-error"));

      if (hasEmailError) {
        validateEmailInput(input, true);
      }
      return;
    }

    if (
      input &&
      input.tagName === "INPUT" &&
      (input.type === "tel" ||
        input.name === "phone-number" ||
        (input.id && input.id.indexOf("phone-number") === 0))
    ) {
      var original = input.value;
      var filtered = original.replace(/[^0-9]/g, "");
      if (original !== filtered) {
        input.value = filtered;
      }
    }
  });

  document.addEventListener(
    "click",
    function (event) {
      var submitBtn = event.target.closest(
        ".contact-section .wpcf7-submit, #contactForm .wpcf7-submit, .contact-right .wpcf7-submit"
      );
      if (!submitBtn) {
        return;
      }

      var form = submitBtn.closest("form.wpcf7-form");
      if (!form) {
        return;
      }

      if (!validateContactFormFields(form, false)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches("form.wpcf7-form")) {
        return;
      }
      if (!form.closest(CONTACT_FORM_ROOT)) {
        return;
      }

      if (!validateContactFormFields(form, false)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener("wpcf7invalid", function (event) {
    var form = event.target;
    if (!form || !form.querySelector) {
      return;
    }

    getEmailInputs(form).forEach(function (input) {
      var wrap = getControlWrap(input);
      if (!wrap) {
        return;
      }

      removeCf7Tips(wrap);

      if (input.classList.contains("wpcf7-not-valid")) {
        validateEmailInput(input, true);
      }
    });
  });

  document
    .querySelectorAll(
      CONTACT_FORM_ROOT +
        ' input[name="first-name"], ' +
        CONTACT_FORM_ROOT +
        ' input[name="last-name"]'
    )
    .forEach(function (input) {
      input.setAttribute("maxlength", String(PERSON_NAME_MAX));
    });

  document.querySelectorAll(".contact-right form.wpcf7-form").forEach(function (contactRightForm) {
    var inputs = contactRightForm.querySelectorAll("input[name]");
    inputs.forEach(function (input) {
      if (input.name && !input.id) {
        input.id = input.name;
      }
    });

    var submitInput = contactRightForm.querySelector("input.wpcf7-submit");
    if (submitInput) {
      var btn = document.createElement("button");
      btn.type = "submit";
      btn.className = submitInput.className + " transparent-btn";
      btn.id = submitInput.id || "contactSubmitBtn";
      btn.name = submitInput.name;
      btn.innerHTML = "Submit";
      submitInput.parentNode.replaceChild(btn, submitInput);
    }
  });

  var contactSubmit = document.querySelector(
    ".contact-section form .wpcf7-submit, .contact-section form button.wpcf7-submit"
  );
  if (contactSubmit && !contactSubmit.id) {
    contactSubmit.id = "contactSubmitBtn";
  }
});
